export const DEFAULT_ORGANIZATION_TIMEZONE = { value: 'US/Eastern', label: 'US/Eastern', id: 29 };
